import React from 'react'
import { personalizedServingText } from '../helpers/personalizedServingText'

export const ServingCitiesText = ({ path }) => {
    const classes = path.includes('blog') ? 'block' : 'hidden';

    return <p className={classes + ' text-base font-semibold'}>{personalizedServingText(path)}</p>;
};
